import { changeMouseCursor } from '../../actions/onDemand'
import { dummyAction } from '../../actions/signaling'

require('../../proto/javascript/netop_rc_mouse_pb')

/**
 * Parse protobuf messages arriving on mouse channel of a webrtc connection
 */
export class MouseMessageParser {

  constructor () {
    this.parseMap = {
      [proto.netop.rc.mouse.MouseMessageType.CURSOR]: (binaryMsg) => {
        const msg = proto.netop.rc.mouse.MouseCursor.deserializeBinary(binaryMsg)
        const objAnswer = msg.toObject()

        const payload = {
          hotspotX: objAnswer.hotspotx,
          hotspotY: objAnswer.hotspoty,
          cursorImage: objAnswer.cursorimage,
        }

        return changeMouseCursor(payload)
      }
    }
  }

  default = (/* type */) => () => {
    // ignore silently the messages with unknown type
    return dummyAction()
  }

  parse = (binaryMsg) => {
    const mouseMsg = proto.netop.rc.mouse.MouseMessage.deserializeBinary(binaryMsg)
    const type = mouseMsg.getMessageType()

    const parser = this.parseMap[type] || this.default(type)
    return parser(binaryMsg)
  }
}
